import { connect, shallowEqual } from 'react-redux';
import React, { useMemo } from 'react';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { setAlpha } from '@sas/nova-commons/design-tokens';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { getFormatInstance } from '@sas-dvr/ltjs-sasicu/util/SASFormatterUtil';
import { useFormatLocale } from '@sas/nova-commons/locale/formatting';
import { exposeTestId } from '../../../config';
import { useI18n } from '../../../locale/I18nContext';
import './SelectionsContent.css';
import cn from './SelectionsContent.css.json';
function getLabel(localize, info, value, measure) {
    if (info.valueColumnLabel) {
        if (measure && info.measureColumnLabel) {
            return localize({
                key: 'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt',
                args: {
                    categoryLabel: info.valueColumnLabel,
                    categoryValue: value,
                    measureLabel: info.measureColumnLabel,
                    measureValue: measure,
                },
            });
        }
        return localize({
            key: 'PromptElement.categoryLabelValueTooltip.fmt',
            args: {
                categoryLabel: info.valueColumnLabel,
                categoryValue: value,
            },
        });
    }
    return value;
}
function selectChildSelections(state, ui, id) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42;
    // errors and assign data states can have sample data
    const hasBadData = ((_a = ui.warning[id]) === null || _a === void 0 ? void 0 : _a.type) === 'error' || ((_b = ui.status[id]) === null || _b === void 0 ? void 0 : _b.type);
    if (state.ButtonBar[id]) {
        if (hasBadData) {
            return {
                name: (_d = (_c = state.ButtonBar[id]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                type: 'no-selections',
            };
        }
        const index = (_e = state.ButtonBar[id]) === null || _e === void 0 ? void 0 : _e.selectedIndex;
        return {
            type: 'value',
            value: (_g = (_f = state.ButtonBar[id]) === null || _f === void 0 ? void 0 : _f.values) === null || _g === void 0 ? void 0 : _g[index],
            measure: (_j = (_h = state.ButtonBar[id]) === null || _h === void 0 ? void 0 : _h.measureValues) === null || _j === void 0 ? void 0 : _j[index],
            name: (_l = (_k = state.ButtonBar[id]) === null || _k === void 0 ? void 0 : _k.name) !== null && _l !== void 0 ? _l : '',
            valueColumnLabel: (_m = state.ButtonBar[id]) === null || _m === void 0 ? void 0 : _m.valueColumnLabel,
            measureColumnLabel: (_o = state.ButtonBar[id]) === null || _o === void 0 ? void 0 : _o.measureColumnLabel,
        };
    }
    if (state.CheckboxList[id]) {
        if (hasBadData) {
            return {
                name: (_q = (_p = state.CheckboxList[id]) === null || _p === void 0 ? void 0 : _p.name) !== null && _q !== void 0 ? _q : '',
                type: 'no-selections',
            };
        }
        return {
            type: 'values',
            indices: (_r = state.CheckboxList[id]) === null || _r === void 0 ? void 0 : _r.selectedIndices,
            values: (_s = state.CheckboxList[id]) === null || _s === void 0 ? void 0 : _s.values,
            measureValues: (_t = state.CheckboxList[id]) === null || _t === void 0 ? void 0 : _t.measureValues,
            name: (_v = (_u = state.CheckboxList[id]) === null || _u === void 0 ? void 0 : _u.name) !== null && _v !== void 0 ? _v : '',
            valueColumnLabel: (_w = state.CheckboxList[id]) === null || _w === void 0 ? void 0 : _w.valueColumnLabel,
            measureColumnLabel: (_x = state.CheckboxList[id]) === null || _x === void 0 ? void 0 : _x.measureColumnLabel,
        };
    }
    if (state.RadioList[id]) {
        if (hasBadData) {
            return {
                name: (_z = (_y = state.RadioList[id]) === null || _y === void 0 ? void 0 : _y.name) !== null && _z !== void 0 ? _z : '',
                type: 'no-selections',
            };
        }
        const index = (_0 = state.RadioList[id]) === null || _0 === void 0 ? void 0 : _0.selectedIndex;
        return {
            type: 'value',
            value: (_2 = (_1 = state.RadioList[id]) === null || _1 === void 0 ? void 0 : _1.values) === null || _2 === void 0 ? void 0 : _2[index],
            measure: (_4 = (_3 = state.RadioList[id]) === null || _3 === void 0 ? void 0 : _3.measureValues) === null || _4 === void 0 ? void 0 : _4[index],
            name: (_6 = (_5 = state.RadioList[id]) === null || _5 === void 0 ? void 0 : _5.name) !== null && _6 !== void 0 ? _6 : '',
            valueColumnLabel: (_7 = state.RadioList[id]) === null || _7 === void 0 ? void 0 : _7.valueColumnLabel,
            measureColumnLabel: (_8 = state.RadioList[id]) === null || _8 === void 0 ? void 0 : _8.measureColumnLabel,
        };
    }
    if (state.ComboBox[id]) {
        if (hasBadData) {
            return {
                name: (_10 = (_9 = state.ComboBox[id]) === null || _9 === void 0 ? void 0 : _9.name) !== null && _10 !== void 0 ? _10 : '',
                type: 'no-selections',
            };
        }
        const index = (_11 = state.ComboBox[id]) === null || _11 === void 0 ? void 0 : _11.selectedIndex;
        return {
            type: 'value',
            value: (_13 = (_12 = state.ComboBox[id]) === null || _12 === void 0 ? void 0 : _12.values) === null || _13 === void 0 ? void 0 : _13[index],
            measure: (_15 = (_14 = state.ComboBox[id]) === null || _14 === void 0 ? void 0 : _14.measureValues) === null || _15 === void 0 ? void 0 : _15[index],
            name: (_17 = (_16 = state.ComboBox[id]) === null || _16 === void 0 ? void 0 : _16.name) !== null && _17 !== void 0 ? _17 : '',
            valueColumnLabel: (_18 = state.ComboBox[id]) === null || _18 === void 0 ? void 0 : _18.valueColumnLabel,
            measureColumnLabel: (_19 = state.ComboBox[id]) === null || _19 === void 0 ? void 0 : _19.measureColumnLabel,
        };
    }
    if (state.TextField[id]) {
        if (hasBadData) {
            return {
                name: (_21 = (_20 = state.TextField[id]) === null || _20 === void 0 ? void 0 : _20.name) !== null && _21 !== void 0 ? _21 : '',
                type: 'no-selections',
            };
        }
        const value = (_22 = state.TextField[id]) === null || _22 === void 0 ? void 0 : _22.formattedValue;
        const values = (_23 = state.TextField[id]) === null || _23 === void 0 ? void 0 : _23.values;
        const index = (_24 = values === null || values === void 0 ? void 0 : values.indexOf(value)) !== null && _24 !== void 0 ? _24 : -1;
        // if (value && !values) Numeric parameter
        // if (index === -1) There are no selections or we have an invalid value
        if ((value && !values) || ((_25 = state.TextField[id]) === null || _25 === void 0 ? void 0 : _25.error) || index === -1) {
            return {
                type: 'value',
                value,
                name: (_27 = (_26 = state.TextField[id]) === null || _26 === void 0 ? void 0 : _26.name) !== null && _27 !== void 0 ? _27 : '',
                valueColumnLabel: (_28 = state.TextField[id]) === null || _28 === void 0 ? void 0 : _28.valueColumnLabel,
            };
        }
        return {
            type: 'value',
            value: value,
            name: (_30 = (_29 = state.TextField[id]) === null || _29 === void 0 ? void 0 : _29.name) !== null && _30 !== void 0 ? _30 : '',
            measure: (_32 = (_31 = state.TextField[id]) === null || _31 === void 0 ? void 0 : _31.measureValues) === null || _32 === void 0 ? void 0 : _32[index],
            valueColumnLabel: (_33 = state.TextField[id]) === null || _33 === void 0 ? void 0 : _33.valueColumnLabel,
            measureColumnLabel: (_34 = state.TextField[id]) === null || _34 === void 0 ? void 0 : _34.measureColumnLabel,
        };
    }
    if (state.Slider[id]) {
        if (hasBadData) {
            return {
                name: (_36 = (_35 = state.Slider[id]) === null || _35 === void 0 ? void 0 : _35.name) !== null && _36 !== void 0 ? _36 : '',
                type: 'no-selections',
            };
        }
        return {
            type: 'range',
            values: (_37 = state.Slider[id]) === null || _37 === void 0 ? void 0 : _37.values,
            name: (_39 = (_38 = state.Slider[id]) === null || _38 === void 0 ? void 0 : _38.name) !== null && _39 !== void 0 ? _39 : '',
            valueColumnLabel: (_40 = state.Slider[id]) === null || _40 === void 0 ? void 0 : _40.valueColumnLabel,
            format: (_42 = (_41 = state.Slider[id]) === null || _41 === void 0 ? void 0 : _41.format) !== null && _42 !== void 0 ? _42 : '',
        };
    }
}
// forked from non exported function in MenuListDesign
function getMenuThemeTokens(dt, overrides) {
    var _a;
    if ((_a = overrides === null || overrides === void 0 ? void 0 : overrides.normal) === null || _a === void 0 ? void 0 : _a.fg) {
        return {
            'title-fg': overrides.normal.fg,
            'divider-bd': dt.themeVariant === 'high-contrast'
                ? overrides.normal.fg
                : setAlpha(overrides.normal.fg, 0.5),
        };
    }
    switch (dt.themeVariant) {
        case 'dark':
            return {
                'title-fg': dt.c.white,
                'divider-bd': dt.c.white15,
            };
        case 'high-contrast':
            return {
                'title-fg': dt.c.white,
                'divider-bd': dt.c.white,
            };
        default:
            return {
                'title-fg': dt.c.n_3,
                'divider-bd': dt.c.n3,
            };
    }
}
const SelectionsContentBase = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const dt = useDesignTokens();
    const formatLocale = useFormatLocale();
    const localize = useI18n();
    const selections = useMemo(() => {
        const processedSelections = [];
        const noSelections = localize({ key: 'PromptContainerTooltip.noSelections.txt' });
        for (const selection of props.childSelections) {
            const item = {
                name: selection.name,
                selections: [],
            };
            switch (selection.type) {
                case 'no-selections': {
                    item.selections = [noSelections];
                    break;
                }
                case 'value': {
                    item.selections = [
                        selection.value
                            ? getLabel(localize, selection, selection.value, selection.measure)
                            : noSelections,
                    ];
                    break;
                }
                case 'values': {
                    const indices = selection.indices;
                    const values = selection.values;
                    const measureValues = selection.measureValues;
                    if (!indices || !values) {
                        item.selections = [noSelections];
                        break;
                    }
                    for (const index of indices) {
                        const val = values[index];
                        if (!val) {
                            continue;
                        }
                        item.selections.push(getLabel(localize, selection, val, measureValues === null || measureValues === void 0 ? void 0 : measureValues[index]));
                    }
                    if (!item.selections.length) {
                        item.selections.push(noSelections);
                    }
                    break;
                }
                case 'range': {
                    if (!selection.values) {
                        item.selections.push(noSelections);
                        break;
                    }
                    const formatter = getFormatInstance(selection.format, formatLocale);
                    const format = (value) => {
                        if (formatter) {
                            return formatter.format(value);
                        }
                        return value;
                    };
                    if (selection.values.max !== undefined && !isNaN(selection.values.max)) {
                        item.selections.push(localize({
                            key: 'RangeSlider.tooltip.fmt',
                            args: {
                                label: selection.valueColumnLabel || '',
                                max: format(selection.values.max) + '',
                                min: format(selection.values.min) + '',
                            },
                        }));
                    }
                    else {
                        item.selections.push(getLabel(localize, selection, `${format(selection.values.min)}`));
                    }
                    break;
                }
            }
            processedSelections.push(item);
        }
        return processedSelections;
    }, [formatLocale, localize, props.childSelections]);
    const style = ((_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.font) === null || _b === void 0 ? void 0 : _b.fontFamily)
        ? { fontFamily: (_d = (_c = props.style) === null || _c === void 0 ? void 0 : _c.font) === null || _d === void 0 ? void 0 : _d.fontFamily }
        : undefined;
    return (React.createElement("div", { "data-testid": exposeTestId() ? `${props.id}-selectionsContent` : undefined, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, style: Object.assign(Object.assign({}, style), renderInlineCssVars(Object.assign(Object.assign({}, getMenuThemeTokens(dt, props.style)), { 'font-size': (_g = (_f = (_e = props.style) === null || _e === void 0 ? void 0 : _e.font) === null || _f === void 0 ? void 0 : _f.fontSize) !== null && _g !== void 0 ? _g : dt.reportTokens.font.size.l }), 'selections')) },
        React.createElement("div", { className: cn.title }, localize({ key: 'PromptContainerTooltip.selectedValues.txt' })),
        React.createElement("div", { className: cn.divider }),
        React.createElement(Flow, { className: cn.selectionsContainer, orientation: "vertical", spacing: "m" }, selections.map((selection, index) => (React.createElement("div", { key: index },
            React.createElement("span", { className: cn.label },
                selection.name,
                ":"),
            selection.selections.map((sel, index) => (React.createElement("span", { key: index, className: cn.value }, sel)))))))));
};
export const SelectionsContent = connect((state, props) => {
    var _a;
    const children = (_a = state.ui.birdLayout.byId[props.id]) === null || _a === void 0 ? void 0 : _a.childKeys;
    const childSelections = [];
    if (!children) {
        return { childSelections };
    }
    for (const childId of children) {
        const selectionInfo = selectChildSelections(state.birdElements, state.ui, childId);
        if (selectionInfo) {
            childSelections.push(selectionInfo);
        }
    }
    return {
        childSelections,
    };
}, undefined, undefined, {
    areStatePropsEqual: (next, prev) => {
        const nextSelections = next === null || next === void 0 ? void 0 : next.childSelections;
        const prevSelections = prev === null || prev === void 0 ? void 0 : prev.childSelections;
        if (!nextSelections || !prevSelections) {
            return nextSelections === prevSelections;
        }
        if (nextSelections.length !== prevSelections.length) {
            return false;
        }
        for (let i = nextSelections.length - 1; i >= 0; i--) {
            if (!shallowEqual(nextSelections[i], prevSelections[i])) {
                return false;
            }
        }
        return true;
    },
})(SelectionsContentBase);
